<template>
  <div class="uni-input">
    <label class="uni-body" v-if="label" :for="id" >{{ label }}</label>
    <span v-if="option" class="uni-caption">Optionnel</span>
    <slot />
    <!--<div>
      <p class="uni-caption infos">
        {{ infos }}
      </p>
    </div>-->
  </div>
</template>

<script>
    export default {
        name: "UniInputContainer",
      props:{
        label: String,
        id: String,
        infos: String,
        option: {
          type: Boolean,
          default: false,
        }
      }
    }
</script>

<style scoped lang="scss">

  .uni-input{
    margin-bottom:var(--s-m);
    width: 100%;
  }
  label{
    margin-bottom:var(--s-xxs);
    margin-left:1px;
    color:var(--color-typo);
  }
  /*.infos{
    margin: 4px 0 0 $s-xs;
    color:$color-grey;
    font-weight: 400;
  }*/

</style>
